import * as React from "react";

import {
  CircularProgress,
  Collapse,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Rating } from "@mui/lab";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import RoundButton from "../../../../../../common/button/RoundButton";
import { setLogin } from "../../../../../../../redux/slices/publicSlice";
import { postOrganizationScores } from "../../../../../../../services/AgapeAPI";
import useError from "../../../../../../../helpers/useError";
import { isAuthenticated } from "../../../../../../../services/Auth";

const useStyles = makeStyles((theme) => ({
  starsContainer: {
    margin: "auto",
    marginTop: "20px",
    // height: '100%',
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
    },
  },
  starsContainer2: {
    margin: "auto",
    marginTop: "50px",
    marginBottom: "50px",
    // height: '100%',
    [theme.breakpoints.down("md")]: {
      margin: "auto",
      marginTop: "0",
      marginBottom: "0",
    },
  },
  singleStar2: {
    "& p": {
      fontSize: "1.818rem !important",
      fontFamily: "Vazir-Medium",
      color: "rgba(33, 33, 33, 0.87)",
    },
    "& .MuiRating-root span": {
      fontSize: "3rem",
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },
  header: {
    // marginBottom: "50px",
    "& p": {
      textAlign: "center",
      //   fontSize: "2.909rem !important",
      fontFamily: "Vazir-Medium",
      [theme.breakpoints.down("md")]: {
        fontSize: "1.9rem !important",
      },
    },
  },
  scoreBtn: {
    minWidth: "200px",
    textAlign: "center",
    margin: "10px",
    marginTop: "30px",
    fontSize: "1.618rem !important",
    [theme.breakpoints.down("md")]: {
      margin: "auto",
    },
  },
  formContainer: {
    width: "100%",
  },
  t1: {
    padding: 10,
    display: "inline-block",
  },
  title: {
    color: "#292929",
    fontSize: 18,
    fontWeight: "bold",
    marginTop: "20px",
  },
}));

const UserCreateRate = ({ code, userRate, getData }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  //   const [hover1, setHover1] = React.useState(0);
  //   const [hover2, setHover2] = React.useState(0);
  //   const [hover3, setHover3] = React.useState(0);
  //   const [hover4, setHover4] = React.useState(0);
  //   const [hover5, setHover5] = React.useState(0);
  //   const [hover6, setHover6] = React.useState(0);
  const [loading, setLoading] = React.useState(false);

  const setIsLoginOpen = (payload) => {
    dispatch(setLogin(payload));
  };

  const errorHook = useError();
  const setError = (err) => errorHook(err);

  return (
    <Formik
      initialValues={{
        financialTransparency:
          userRate && userRate[0] ? userRate[0].transparency : 0,
        reportingToSponsors: userRate && userRate[0] ? userRate[0].report : 0,
        administrativeDiscipline:
          userRate && userRate[0] ? userRate[0].discipline : 0,
        qualityOfService:
          userRate && userRate[0] ? userRate[0].service_quality : 0,
        responseStyle: userRate && userRate[0] ? userRate[0].responsiveness : 0,
        totalPerformance: userRate && userRate[0] ? userRate[0].performance : 0,
      }}
      onSubmit={(values) => {
        if (isAuthenticated()) {
          setLoading(true);
          postOrganizationScores(code, {
            transparency: values.financialTransparency,
            report: values.reportingToSponsors,
            discipline: values.administrativeDiscipline,
            service_quality: values.qualityOfService,
            responsiveness: values.responseStyle,
            performance: values.totalPerformance,
          })
            .then((response) => {
              getData();
              toast.success("امتیاز با موفقیت ثبت شد");
              setLoading(false);
            })
            .catch((ex) => {
              setError(ex);
              setLoading(false);
            });
        } else {
          setIsLoginOpen(true);
        }
      }}
    >
      {({
        values,
        errors,
        isSubmitting,
        isValid,
        handleSubmit,
        handleChange,
        handleBlur,
        handleReset,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className={classes.formContainer}>
          <Grid item xs={12} sm={12} md={12} className={classes.header}>
            <Typography
              variant="h4"
              className={classes.title}
              onClick={getData}
            >
              شما هم به این سازمان امتیاز دهید
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            container
            alignItems="center"
            className={classes.starsContainer}
          >
            <Grid container className={classes.singleStar2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Rating
                  dir="ltr"
                  name="financialTransparency"
                  size="large"
                  precision={1}
                  defaultValue={0}
                  value={values.financialTransparency}
                  className={classes.rate}
                  onChange={handleChange}
                  //   onChangeActive={(event, newHover) => {
                  //     setHover1(newHover);
                  //   }}
                />
                <Typography variant="h5" className={classes.t1}>
                  شفافیت مالی
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.singleStar2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Rating
                  dir="ltr"
                  name="reportingToSponsors"
                  size="large"
                  precision={1}
                  defaultValue={0}
                  value={values.reportingToSponsors}
                  className={classes.rate}
                  onChange={handleChange}
                  //   onChangeActive={(event, newHover) => {
                  //     setHover2(newHover);
                  //   }}
                />
                <Typography variant="h5" className={classes.t1}>
                  گزارش دهی به حامیان
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.singleStar2}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Rating
                  dir="ltr"
                  name="administrativeDiscipline"
                  size="large"
                  precision={1}
                  defaultValue={0}
                  value={values.administrativeDiscipline}
                  className={classes.rate}
                  onChange={handleChange}
                  //   onChangeActive={(event, newHover) => {
                  //     setHover3(newHover);
                  //   }}
                />
                <Typography variant="h5" className={classes.t1}>
                  انضباط اداری
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid container className={classes.singleStar2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Rating
                dir="ltr"
                name="qualityOfService"
                size="large"
                precision={1}
                defaultValue={0}
                value={values.qualityOfService}
                className={classes.rate}
                onChange={handleChange}
                //   onChangeActive={(event, newHover) => {
                //     setHover4(newHover);
                //   }}
              />
              <Typography variant="h5" className={classes.t1}>
                کیفیت خدمات
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.singleStar2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Rating
                dir="ltr"
                name="responseStyle"
                size="large"
                precision={1}
                defaultValue={0}
                value={values.responseStyle}
                className={classes.rate}
                onChange={handleChange}
                //   onChangeActive={(event, newHover) => {
                //     setHover5(newHover);
                //   }}
              />
              <Typography variant="h5" className={classes.t1}>
                شیوه پاسخگویی
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.singleStar2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Rating
                dir="ltr"
                name="totalPerformance"
                size="large"
                precision={1}
                defaultValue={0}
                value={values.totalPerformance}
                className={classes.rate}
                onChange={handleChange}
                //   onChangeActive={(event, newHover) => {
                //     setHover6(newHover);
                //   }}
              />
              <Typography variant="h5" className={classes.t1}>
                عملکرد سازمان در مجموع
              </Typography>
            </Grid>
          </Grid>
          <Grid item container md={12} justify="flex-end">
            <RoundButton
              customClassName={classes.scoreBtn}
              onClick={handleSubmit}
              disabled={
                +values.financialTransparency < 1 ||
                +values.reportingToSponsors < 1 ||
                +values.administrativeDiscipline < 1 ||
                +values.qualityOfService < 1 ||
                +values.responseStyle < 1 ||
                +values.totalPerformance < 1
              }
            >
              {loading ? (
                <CircularProgress size={30} color="white" />
              ) : (
                "ثبت امتیازات"
              )}
            </RoundButton>
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default UserCreateRate;
